export default __webpack_public_path__ + "static/media/insightdata_statistique.0e974148.svg";